import React from 'react';
import { LoginForm } from '../../toolympus/components/auth';
import { useLoginForm } from '../../toolympus/hooks/auth';
import { useReturnUrl } from '../../toolympus/hooks/auth/useReturnUrl';
import { PublicPageWrapper } from '../Common/PublicPageWrapper';
import { Button } from '@mui/material';
import { ICLRCAuthLogo } from './LoginKC';

export const LoginContainer = () => {
    const returnUrl = useReturnUrl();
    const signupData = useLoginForm("/api/login", returnUrl.fromParam || "/");
    return <PublicPageWrapper>
        <LoginForm
          loginData={signupData}
          extraActions={<>
            <Button color="primary" href={`/login?login=${signupData.data.login}`}>войти по коду</Button>
            <Button color="primary" href="/login-kc-start"><ICLRCAuthLogo /></Button>
          </>}
          />
    </PublicPageWrapper>;
}